import { create } from 'zustand';

export type RealtimeStatus = 'disconnected' | 'connecting' | 'connected' | 'reconnecting';

export interface RealtimeState {
  status: RealtimeStatus;
  lastConnectedAt: number | null;
  lastError: Error | null;
  attempts: number;
  setStatus: (status: RealtimeStatus) => void;
  noteError: (e: Error | null) => void;
  noteAttempt: () => void;
  reset: () => void;
}

export const useRealtimeStore = create<RealtimeState>((set) => ({
  status: 'disconnected',
  lastConnectedAt: null,
  lastError: null,
  attempts: 0,
  setStatus: (status) =>
    set((s) => ({
      status,
      lastConnectedAt: status === 'connected' ? Date.now() : s.lastConnectedAt
    })),
  noteError: (lastError) => set({ lastError }),
  noteAttempt: () => set((s) => ({ attempts: s.attempts + 1 })),
  reset: () => set({ status: 'disconnected', lastError: null, attempts: 0 })
}));
